export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.log('Error retrieving state from localstorage');
        // ADD BETTER ERROR HANDLING
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        console.log('Error storing state in localstorage');
        // ADD BETTER ERROR HANDLING
    }
};

export const deleteState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState !== null) {
            localStorage.setItem('state', null);
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.log('Error retrieving state from localstorage');
        // ADD BETTER ERROR HANDLING
        return undefined;
    }
};
